import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-5" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-field-checkbox" }
const _hoisted_13 = { for: "isActive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: true,
    class: "kn-dialog--toolbar--primary",
    header: _ctx.formHeader,
    closable: false,
    style: _ctx.configurationManagementDescriptor.form.style
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeTemplate
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        disabled: _ctx.buttonDisabled,
        onClick: _ctx.handleSubmit
      }, null, 8, ["label", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", {
          class: "p-field",
          style: _ctx.configurationManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_2, [
            _createVNode(_component_InputText, {
              id: "label",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.configuration.label.$invalid && _ctx.v$.configuration.label.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.configuration.label.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.configuration.label.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "100",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.configuration.label.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.label')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.configuration.label,
            additionalTranslateParams: {
                        fieldName: _ctx.$t('managers.configurationManagement.headers.label')
                    }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.configurationManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.configuration.name.$invalid && _ctx.v$.configuration.name.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.configuration.name.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.configuration.name.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "100",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.configuration.name.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.configuration.name,
            additionalTranslateParams: {
                        fieldName: _ctx.$t('managers.configurationManagement.headers.name')
                    }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.configurationManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "description",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.configuration.description.$invalid && _ctx.v$.configuration.description.$dirty
                        }],
              type: "text",
              modelValue: _ctx.v$.configuration.description.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.configuration.description.$model = $event)),
              modelModifiers: { trim: true },
              maxLength: "500",
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.configuration.description.$touch()))
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.description')), 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.configuration.description,
            additionalTranslateParams: {
                        fieldName: _ctx.$t('managers.configurationManagement.headers.description')
                    }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.configurationManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_Dropdown, {
              id: "category",
              class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.configuration.category.$invalid && _ctx.v$.configuration.category.$dirty
                        }],
              modelValue: _ctx.v$.configuration.category.$model,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.configuration.category.$model = $event)),
              options: _ctx.configurationManagementDescriptor.category,
              optionLabel: "name",
              optionValue: "value",
              onBeforeShow: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.configuration.category.$touch()))
            }, null, 8, ["modelValue", "class", "options"]),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.category')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.configuration.category,
            additionalTranslateParams: {
                        fieldName: _ctx.$t('managers.configurationManagement.headers.category')
                    }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.configurationManagementDescriptor.pField.style
        }, [
          _createVNode("span", _hoisted_10, [
            _createVNode(_component_InputText, {
              id: "description",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.v$.configuration.valueCheck.$model,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.configuration.valueCheck.$model = $event)),
              modelModifiers: { trim: true },
              onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.configuration.valueCheck.$touch()))
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.valueCheck')), 1)
          ])
        ], 4),
        _createVNode("div", {
          class: "p-field",
          style: _ctx.configurationManagementDescriptor.pField.style
        }, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Checkbox, {
              id: "isActive",
              modelValue: _ctx.v$.configuration.active.$model,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.configuration.active.$model = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.configurationManagement.headers.active')), 1)
          ])
        ], 4)
      ])
    ]),
    _: 1
  }, 8, ["header", "style"]))
}